export default "__VITE_ASSET__e7QL0MfS0eB1H0TdFd7NwQ__"